import React, { useState } from 'react';
import I18n from 'i18n-js';
import RecentArticles from './recent_articles';
import HomepageCategories from '../homepage_categories';
import HomepageSell from './homepage_sell';
import HomepageNewsletter from './homepage_newsletter';
import HomepageDealsAndStealsListingsCollection from '../../homepage_deals_and_steals_listings_collection';
import SignupSigninModal from '@reverbdotcom/commons/src/components/signup_signin_modal';
import LoggedOutRecommendationsRow from '../../recommended_listings/logged_out_recommendations_row';
import CmsListingsCollection from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import EmptyStateWatchedListings from '@reverbdotcom/commons/src/components/empty_state_watched_listings';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import UrlHelpers from '../../shared/url_helpers';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import HomepageTrendingSearches from './homepage_trending_searches';
import HomePageSellVisibilityV2 from './homepage_sell_visibility_v2';

export function LoggedOutHomepage() {
  const user = useUser();
  const [showSignUp, setShowSignUp] = useState(false);
  
  function handleSignUp(event) {
    setShowSignUp(true);
    event.stopPropagation();
    event.preventDefault();
  }

  const trackingData = {
    eventName: MParticleEventName.ComponentView,
    componentName: 'EmptyStateWatchedListings',
    experiments: formatExperimentsForEventAttributes(user, [experiments.HOMEPAGE_LOGGED_OUT_EMPTY_WATCHLIST]),
  };

  useViewTracking(trackingData, true);

   
  return (
    <>
      <div className="mb-3">
        <CmsEmbed slug="logged-out-homepage" ssrMode="full" />
      </div>
      <div className="homepage-container bg-white pt-half">
        <LoggedOutRecommendationsRow />
        <HomePageSellVisibilityV2 />
        { isExperimentEnabled(user, experiments.HOMEPAGE_LOGGED_OUT_EMPTY_WATCHLIST) &&
          <div className="homepage-container__component-wrapper">
            <EmptyStateWatchedListings
              user={user}
              secondaryCallToAction={(
                <a
                  href={UrlHelpers.signupPath()}
                  onClick={handleSignUp}
                  className="button button--inverse mr-half mobile-mb-half"
                >
                  {I18n.t('commons.watchRow.loggedOut.emptyState.cta')}
                </a>
              )}
            />
          </div>
        }
        <HomepageTrendingSearches />
        <div className="homepage-container__component-wrapper">
          <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
        </div>
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.shopByInstrument')}
        </h2>
        <div className="homepage-container__component-wrapper homepage-container__component-wrapper--thin">
          <HomepageCategories noTitle />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.explore')}
          </h2>
          <RecentArticles title=" " />
        </div>
        <div className="scaling-mb-7 scaling-mt-10">
          <HomepageNewsletter signupReason="loggedouthomepage" />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.latestGear')}
          </h2>
          <CmsListingsCollection
            ctaTargetHref="/marketplace?condition=used"
            conditionSlugs={['used']}
            userShippingRegion={user.shippingRegionCode}
            componentName="HomepageLatestListings"
            maxCount={12}
            largeTiles
            ssr={false}
          />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.dealsAndSteals')}
          </h2>
          <HomepageDealsAndStealsListingsCollection />
        </div>
        <div className="scaling-mt-10 pb-5 mobile-pb-0">
          <HomepageSell />
        </div>
        <SignupSigninModal
          onRequestClose={() => setShowSignUp(false)}
          active={showSignUp}
        />
      </div>
    </>
  );
}

export default LoggedOutHomepage;
